import React from 'react';
import { ModalContent, ModalFooter } from 'fronton-react';
import { css } from 'linaria';
import { ButtonWithGAClickButton, List, ModalHeader, Typography } from 'common/components';
import { INTERIOR_DOORS_ELEMENT_BLOCK } from '../../../../interior-doors-constants';

const assortmentText = css`
  margin-bottom: 8px;
`;

const assortmentModalList = css`
  && {
    margin-bottom: 8px;

    li {
      margin-bottom: 0;

      &:not(:last-child) {
        margin-bottom: 4px;
      }
    }
  }
`;

type BenefitsProps = {
  onConsultationSignupBtnClick: () => void;
};

export const Assortment = ({ onConsultationSignupBtnClick }: BenefitsProps) => (
  <>
    <ModalHeader title="Широкий ассортимент" />
    <ModalContent>
      <Typography className={assortmentText} variant="m" size="body_long">
        При подборе нашего ассортимента мы&nbsp;ориентируемся на&nbsp;тренды в&nbsp;дизайне интерьеров.
        На&nbsp;выбор больше 100 моделей дверей в&nbsp;разных стилях и&nbsp;оттенках. Также возможны разные
        способы открывания дверей:
      </Typography>
      <List className={assortmentModalList} listStyle="disc">
        <li>
          <Typography variant="m" size="body_long">
            распашные;
          </Typography>
        </li>
        <li>
          <Typography variant="m" size="body_long">
            раздвижные;
          </Typography>
        </li>
        <li>
          <Typography variant="m" size="body_long">
            скрытый монтаж;
          </Typography>
        </li>
        <li>
          <Typography variant="m" size="body_long">
            складные двери «книжка».
          </Typography>
        </li>
      </List>
      <Typography variant="m" size="body_long">
        Некоторые модели представлены в&nbsp;нестандартных размерах: 40&nbsp;см в&nbsp;ширину и&nbsp;190,
        210, 220, 230&nbsp;см в&nbsp;высоту.
      </Typography>
    </ModalContent>
    <ModalFooter>
      <ButtonWithGAClickButton
        elementBlock={INTERIOR_DOORS_ELEMENT_BLOCK}
        elementName="Записаться на консультацию"
        elementText="Широкий ассортимент"
        onClick={onConsultationSignupBtnClick}
        wide>
        Записаться на консультацию
      </ButtonWithGAClickButton>
    </ModalFooter>
  </>
);
